export default __webpack_public_path__ + "6d27406b02b6443d249026d573649ab3.png";